export default __webpack_public_path__ + "static/ctmBanner-6301881f5b8741699e5314991de1bc1a.png";